import { useSelector } from "react-redux";
import arrowPrev from "../../images/arrow-prev.svg";
import styles from "./MyAccount.module.css";

const ArrowBar = ({ onClick }) => {
  const profileSideBarToggle = useSelector(
    (state) => state.profileSideBarToggle
  );
  return (
    <div
      className={`${styles.arrowBar} ${
        profileSideBarToggle ? styles.arrowBarActive : null
      }`}
    >
      <img
        src={arrowPrev}
        alt="Previous Icon"
        className={`${styles.arrowIcon} ${
          profileSideBarToggle ? styles.arrowIconActive : null
        }`}
        onClick={onClick}
      />
    </div>
  );
};

export default ArrowBar;
